/* eslint-disable import/no-anonymous-default-export */
import { AxiosError } from "axios";
import { PartialDeep } from "type-fest";
import { Tag } from "../../common/components/TagInput";
import useApi, { ActionResult, Api, Model, Query, Response } from "../../common/hooks/useApi"
import { Infraccion, InfraccionAgrupada, InfraccionGroupType } from "../../infracciones/hooks/useInfraccionesAPI";
import { OverlaySvg } from "../../overlays-svg/useOverlaysSvgAPI";
import { Usuario } from "../../usuarios/useUsuariosAPI";

export interface LoteRenombrado extends Model {
    NroLote: string
    FechaHora: string
    RenombradorAsignado: Usuario
    CantidadInfracciones: number
    CantidadInfraccionesIlegibles: number
    CantidadInfraccionesEfectivas: number
    UnidadesProdNombre?: string
}


export interface DatosRenombrado {
    Patente?: string
    PatenteX: number
    PatenteY: number
    PatenteZoom: number
    ImagenDestacadaIndice: number
    Extranjero?: boolean
    PatenteIlegible?: boolean
    NoDistinguible?: boolean
    ArchivoPatente: File
    Overlays: OverlaySvg[]
    CodigoInfraccionId?: number
    FechaHora?: string,
    //EtiquetasImagenes?: { EtiquetaIndex: string, Etiqueta: Tag }[]
    EtiquetasImagenes?:{[key:string]:Tag}
    Lugar?:string
}

export interface DatosRenombradoSave extends Omit<DatosRenombrado, 'EtiquetasImagenes'> {
    EtiquetasImagenes: string
}

const module = "LoteRenombrado";

export default () => {
    const api = useApi({ module });

    return {
        list: (query: Query) => api.list!<LoteRenombrado>(query),
        save: (data: Partial<LoteRenombrado>) => api.save!<Partial<LoteRenombrado>, LoteRenombrado>(data),
        delete: (id: number) => api.delete(id),
        assignPending: async (RenombradorId: number, query?: Query, unidadesProd?: string[]): Promise<ActionResult<undefined>> => {
            try {
              let qs = api.queryToString(query ?? {});
              const unidadesProdNombresString = unidadesProd?.join(',');

              await api.axiosInstance.post(`${module}/Asignar?${qs}&unidadesProdNombres=${unidadesProdNombresString}`, { RenombradorId });
          
              return {
                data: { value: undefined }
              };
            } catch (error: any | AxiosError) {
              return {
                error
              };
            }
          },
        renombrar: async (id: number, data: PartialDeep<DatosRenombradoSave>) => {
            try {

                const formData = api.getFormData(data);
                const response = await api.axiosInstance.post(`${module}/Renombrar/${id}`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                });
                return {
                    data: { value: undefined }
                };
            } catch (error: any | AxiosError) {
                console.error(error)
                return {
                    error
                };
            }
        },
        getPendingCount: async (query?: Query): Promise<ActionResult<number>> => {
            try {
                let qs = api.queryToString(query ?? {});
                const response = await api.axiosInstance.get<{ value: number }>(`${module}/VerCantidadPendienteRenombrado?${qs}`);
                return {
                    data: { value: response.data.value }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        editRenombrado: async (id: number, data: PartialDeep<DatosRenombradoSave>) => {
            try {

                const formData = api.getFormData(data);
                const response = await api.axiosInstance.post(`${module}/EditarRenombrado/${id}`, formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    });
                return {
                    data: { value: undefined }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        getAssignedInfractions: async (query?: Query) => {
            try {
                const defaultQuery: Query = { $count: true, $orderby: ["FechaRenombrado asc"], $expand: ["OverlaysImagenes","Imagenes", "ImagenPatente", "Videos", "Equipo($expand=ConfiguracionProduccion)", "EtiquetasImagenes($expand=Etiqueta)"] };
                let qs = api.queryToString(query ? { ...query, ...defaultQuery } : defaultQuery);
                const response = await api.axiosInstance.get<Response<Infraccion[]>>(`${module}/InfraccionesAsignadas?${qs}`);
                return {
                    data: response.data
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        getAssignedInfractionsGroup: async (query?: Query, groupType?: InfraccionGroupType) => {
            try {
                const defaultQuery: Query = {};
                let qs = api.queryToString(query ? { ...query, ...defaultQuery } : defaultQuery);
                const response = await api.axiosInstance.get<InfraccionAgrupada[]>(`${module}/InfraccionesAsignadas/Agrupar?${qs}&groupType=${groupType}`);
                return {
                    data: {
                        value: response.data
                    }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        replaceImageDestacada: async (imagenIdABorrar: string, infraccionId: string, file: File) => {
            try {
              const formdata = new FormData();
              formdata.append("imagenNueva", file);
          
              const response = await api.axiosInstance.post(
                `${module}/CambiarImagen/?imagenIdAborrar=${imagenIdABorrar}&infraccionId=${infraccionId}`,
                formdata,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                  data: formdata, 
                }
              );
              return { data: { value: undefined } };
            } catch (error: any | AxiosError) {
                console.error(error)
                return {
                    error
                };
            }
          }          
    };
}